import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';
// eslint-disable-next-line no-unused-vars,
import { EmployeesSalesTypes, EmployeeSalesInterface } from './types';

// List Employees
export const listEmployeesRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(EmployeesSalesTypes.LIST_EMPLOYEES_REQUEST, payload);
export const listEmployeesSuccess = (payload: {
  employeesList: EmployeeSalesInterface[];
  totalCount: number;
}) => action(EmployeesSalesTypes.LIST_EMPLOYEES_SUCCESS, payload);
export const listEmployeesFailure = () =>
  action(EmployeesSalesTypes.LIST_EMPLOYEES_FAILURE);

// Get Employee
export const getEmployeeRequest = (payload: object) =>
  asyncAction(EmployeesSalesTypes.GET_EMPLOYEE_REQUEST, payload);
export const getEmployeeSuccess = (payload: {
  employeeData: EmployeeSalesInterface;
}) => action(EmployeesSalesTypes.GET_EMPLOYEE_SUCCESS, payload);
export const getEmployeeFailure = () =>
  action(EmployeesSalesTypes.GET_EMPLOYEE_FAILURE);

// Filter Employees
export const filterEmployeesRequest = (payload: object) =>
  action(EmployeesSalesTypes.FILTER_EMPLOYEES_REQUEST, payload);
export const filterEmployeesSuccess = (payload: {
  employeesList: EmployeeSalesInterface[];
  totalCount: number;
}) => action(EmployeesSalesTypes.FILTER_EMPLOYEES_SUCCESS, payload);
export const filterEmployeesFailure = () =>
  action(EmployeesSalesTypes.FILTER_EMPLOYEES_FAILURE);

// Get Employee Sales Resume
export const getEmployeeSalesResumeRequest = (payload: object) =>
  asyncAction(EmployeesSalesTypes.GET_EMPLOYEE_SALES_RESUME_REQUEST, payload);
export const getEmployeeSalesResumeSuccess = (payload: object) =>
  action(EmployeesSalesTypes.GET_EMPLOYEE_SALES_RESUME_SUCCESS, payload);
export const getEmployeeSalesResumeFailure = () =>
  action(EmployeesSalesTypes.GET_EMPLOYEE_SALES_RESUME_FAILURE);

// List Payments
export const listPaymentsRequest = (payload: object) =>
  action(EmployeesSalesTypes.LIST_PAYMENTS_REQUEST, payload);
export const listPaymentsSuccess = (payload: { paymentsList: any[] }) =>
  action(EmployeesSalesTypes.LIST_PAYMENTS_SUCCESS, payload);
export const listPaymentsFailure = () =>
  action(EmployeesSalesTypes.LIST_PAYMENTS_FAILURE);

// List Transactions
export const listTransactionsRequest = (payload: any) =>
  action(EmployeesSalesTypes.LIST_TRANSACTIONS_REQUEST, payload);
export const listTransactionsSuccess = (payload: { transactionsList: any[] }) =>
  action(EmployeesSalesTypes.LIST_TRANSACTIONS_SUCCESS, payload);
export const listTransactionsFailure = () =>
  action(EmployeesSalesTypes.LIST_TRANSACTIONS_FAILURE);

// Add Payment Employee
export const addPaymentEmployeeRequest = (payload: any) =>
  action(EmployeesSalesTypes.ADD_PAYMENT_EMPLOYEE_REQUEST, payload);
export const addPaymentEmployeeSuccess = () =>
  action(EmployeesSalesTypes.ADD_PAYMENT_EMPLOYEE_SUCCESS);
export const addPaymentEmployeeFailure = () =>
  action(EmployeesSalesTypes.ADD_PAYMENT_EMPLOYEE_FAILURE);

// Get Employee Sales Trip Resume
export const getEmployeeSalesTripResumeRequest = (payload: object) =>
  asyncAction(
    EmployeesSalesTypes.GET_EMPLOYEE_SALES_TRIP_RESUME_REQUEST,
    payload,
  );
export const getEmployeeSalesTripResumeSuccess = (payload: object) =>
  action(EmployeesSalesTypes.GET_EMPLOYEE_SALES_TRIP_RESUME_SUCCESS, payload);
export const getEmployeeSalesTripResumeFailure = () =>
  action(EmployeesSalesTypes.GET_EMPLOYEE_SALES_TRIP_RESUME_FAILURE);
